/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiErrorResponse {
  Error: Error
}

export interface CertificateCategory {
  /** @format int32 */
  Id: number
  IsDeleted: boolean
  /** @format date-time */
  CreatedOn?: string | null
  /** @maxLength 100 */
  Name: string
}

export interface CertificateReviewRequest {
  /**
   * Unique identifier of the certificate to be reviewed
   * @format int32
   */
  Id: number
  /**
   *
   *
   * 1 = PendingReview
   *
   * 2 = Approved
   *
   * 3 = Rejected
   *
   * 4 = Expired
   *
   * 5 = Draft
   *
   * 6 = Obsolete
   *
   * 7 = Processed
   */
  StatusId: CertificateStatusType
  /**
   * Optional rejection reason
   * @maxLength 10000
   */
  RejectionReason?: string | null
}

/**
 *
 *
 * 1 = UserCertificate
 *
 * 2 = ProfileCertificate
 *
 * 3 = TenantCertificate
 * @format int32
 */
export enum CertificateScopeType {
  UserCertificate = 1,
  ProfileCertificate = 2,
  TenantCertificate = 3,
}

/**
 *
 *
 * 1 = PendingReview
 *
 * 2 = Approved
 *
 * 3 = Rejected
 *
 * 4 = Expired
 *
 * 5 = Draft
 *
 * 6 = Obsolete
 *
 * 7 = Processed
 * @format int32
 */
export enum CertificateStatusType {
  PendingReview = 1,
  Approved = 2,
  Rejected = 3,
  Expired = 4,
  Draft = 5,
  Obsolete = 6,
  Processed = 7,
}

export interface CertificateTypeBaseResponse {
  /**
   * Unique identifier of the certificate type within the system
   * @format int32
   */
  Id: number
  /** Certificate type name */
  Name: string
  /**
   * Certificate type category id
   * @format int32
   */
  CategoryId: number
  /**
   *
   *
   * 1 = UserCertificate
   *
   * 2 = ProfileCertificate
   *
   * 3 = TenantCertificate
   */
  ScopeId: CertificateScopeType
  /**
   *
   *
   * 1 = System
   *
   * 2 = Corporation
   *
   * 3 = Tenant
   */
  VisibilityScope: CertificateTypeVisibilityScope
  /**
   * Default validity period for the certificate type
   * @format int32
   */
  DefaultValidityPeriod?: number | null
  /**
   *
   *
   * 1 = Day
   *
   * 2 = Month
   *
   * 3 = Year
   */
  DefaultValidityPeriodUnitId?: PeriodUnitType
}

export interface CertificateTypeCreateRequest {
  /**
   * Certificate type name
   * @maxLength 100
   * @pattern ^[\S]+(\s+[\S]+)*$
   */
  Name: string
  /**
   *
   *
   * 1 = System
   *
   * 2 = Corporation
   *
   * 3 = Tenant
   */
  VisibilityScope: CertificateTypeVisibilityScope
  /**
   * Unique id of the category this certificate type belongs to
   * @format int32
   */
  CategoryId: number
  /**
   *
   *
   * 1 = UserCertificate
   *
   * 2 = ProfileCertificate
   *
   * 3 = TenantCertificate
   */
  ScopeId: CertificateScopeType
  /**
   * Default validity period
   * @format int32
   * @min 1
   * @max 2147483647
   */
  DefaultValidityPeriod?: number | null
  /**
   *
   *
   * 1 = Day
   *
   * 2 = Month
   *
   * 3 = Year
   */
  DefaultValidityPeriodUnitId?: PeriodUnitType
}

export interface CertificateTypeResponse {
  /**
   * Unique identifier of the certificate type within the system
   * @format int32
   */
  Id: number
  /** Certificate type name */
  Name: string
  /**
   * Certificate type category id
   * @format int32
   */
  CategoryId: number
  /**
   *
   *
   * 1 = UserCertificate
   *
   * 2 = ProfileCertificate
   *
   * 3 = TenantCertificate
   */
  ScopeId: CertificateScopeType
  /**
   *
   *
   * 1 = System
   *
   * 2 = Corporation
   *
   * 3 = Tenant
   */
  VisibilityScope: CertificateTypeVisibilityScope
  /**
   * Default validity period for the certificate type
   * @format int32
   */
  DefaultValidityPeriod?: number | null
  /**
   *
   *
   * 1 = Day
   *
   * 2 = Month
   *
   * 3 = Year
   */
  DefaultValidityPeriodUnitId?: PeriodUnitType
  /** Flag indicating whether the certificate type is deleted */
  IsDeleted: boolean
  /**
   * Certificate type creation date
   * @format date-time
   */
  CreatedOn: string
  /**
   * Unique identifier of the tenant associated with the certificate type
   * @format int32
   */
  TenantId?: number | null
  /**
   * Unique identifier of the corporation associated with the certificate type
   * @format int32
   */
  CorporationId?: number | null
  /** Certificate category name */
  CategoryName: string
  /**
   * Certificate type creator unique identifier
   * @format uuid
   */
  CreatedBy: string
}

export interface CertificateTypeUpdateRequest {
  /**
   * Unique identifier of the certificate type within the system
   * @format int32
   */
  Id: number
  /**
   * Certificate type name
   * @minLength 1
   * @maxLength 100
   * @pattern ^[\S]+(\s+[\S]+)*$
   */
  Name: string
}

/**
 *
 *
 * 1 = System
 *
 * 2 = Corporation
 *
 * 3 = Tenant
 * @format int32
 */
export enum CertificateTypeVisibilityScope {
  System = 1,
  Corporation = 2,
  Tenant = 3,
}

export interface CertificateUpdateRequest {
  /**
   * Unique identifier of the certificate within the system
   * @format int32
   */
  Id: number
  /**
   * Certificate serial number
   * @maxLength 256
   * @pattern ^[\S]+(\s+[\S]+)*$
   */
  SerialNumber?: string | null
  /**
   * Certificate authority
   * @maxLength 256
   * @pattern ^[\S]+(\s+[\S]+)*$
   */
  Authority?: string | null
  /**
   * Certificate valid from date
   * @format date-time
   */
  ValidFrom: string
  /**
   * Certificate expiration date
   * @format date-time
   */
  ExpirationDate: string
  /**
   *
   *
   * 1 = PendingReview
   *
   * 2 = Approved
   *
   * 3 = Rejected
   *
   * 4 = Expired
   *
   * 5 = Draft
   *
   * 6 = Obsolete
   *
   * 7 = Processed
   */
  StatusId: CertificateStatusType
  /** Certificate document data in base64 format */
  PhotoData?: string | null
  /** List of location ids associated with the certificate */
  LocationIds: number[]
}

export interface CreateCertificateRequest {
  /**
   * Certificate serial number
   * @maxLength 256
   * @pattern ^[\S]+(\s+[\S]+)*$
   */
  SerialNumber?: string | null
  /**
   * Certificate authority
   * @maxLength 256
   * @pattern ^[\S]+(\s+[\S]+)*$
   */
  Authority?: string | null
  /**
   * Certificate type id
   * @format int32
   */
  TypeId: number
  /**
   * Certificate valid from date
   * @format date-time
   */
  ValidFrom: string
  /**
   * Certificate expiration date
   * @format date-time
   */
  ExpirationDate: string
  /**
   * Certificate document data in base64 format
   * @minLength 1
   */
  PhotoData: string
  /** List of location ids associated with the certificate */
  LocationIds: number[]
}

export interface CreateQualificationRequest {
  /**
   * Qualification name
   * @minLength 1
   * @maxLength 256
   * @pattern ^[\S]+(\s+[\S]+)*$
   */
  Name: string
  /**
   * Qualification expiration date
   * @format date-time
   */
  ExpirationDate?: string | null
  /**
   *
   *
   * 1 = Corporation
   *
   * 2 = Tenant
   */
  VisibilityScope: QualificationVisibilityScope
  /**
   * List of certificate type ids associated with the qualification
   * @minItems 1
   */
  CertificateTypeIds: number[]
}

export interface CreateQualificationVersionRequest {
  /**
   * Unique identifier of the qualification within the system
   * @format int32
   */
  QualificationId: number
  /**
   * Qualification version name
   * @maxLength 100
   * @pattern ^[\S]+(\s+[\S]+)*$
   */
  Name: string
  /**
   * Qualification version expiration date
   * @format date-time
   */
  ExpirationDate?: string | null
  /** List of certificate type unique identifiers associated with the qualification version */
  CertificateTypeIds: number[]
}

export interface CreateUserQualificationRequest {
  /**
   * Unique identifier of the user to whom the qualification is being assigned
   * @format uuid
   */
  AssignedToUserGuid: string
  /**
   * Unique identifier of the user to whom the qualification is being assigned
   * @format int32
   */
  AssignedToUserId: number
  /**
   * Unique identifier of the qualification version being assigned
   * @format int32
   */
  QualificationVersionId: number
}

export interface CreateUserQualificationResponse {
  /** Flag indicating whether the user qualification was restored */
  Restored: boolean
}

export interface Error {
  /** @format int32 */
  Code: number
  /** @minLength 1 */
  Message: string
  Details?: string | null
}

export interface GetCertificateResponse {
  /**
   * Unique identifier of the certificate within the system
   * @format int32
   */
  Id: number
  /** Flag indicating whether the certificate is deleted */
  IsDeleted: boolean
  /**
   * Certificate creation date
   * @format date-time
   */
  CreatedOn: string
  /** Certificate serial number */
  SerialNumber?: string | null
  /** Certificate authority */
  Authority?: string | null
  /**
   * Certificate type identifier
   * @format int32
   */
  TypeId: number
  /** Certificate type name */
  TypeName: string
  /**
   *
   *
   * 1 = UserCertificate
   *
   * 2 = ProfileCertificate
   *
   * 3 = TenantCertificate
   */
  ScopeId: CertificateScopeType
  /**
   * Unique identifier of the owner profile associated with the certificate
   * @format int32
   */
  OwnerProfileId?: number | null
  /**
   * Unique identifier of the owner identity associated with the certificate
   * @format uuid
   */
  OwnerIdentityGuid?: string | null
  /**
   * Unique identifier of the tenant associated with the certificate
   * @format int32
   */
  TenantId?: number | null
  /** Name of the tenant associated with the certificate */
  TenantName?: string | null
  /** Subdomain of the tenant associated with the certificate */
  TenantSubdomain?: string | null
  /**
   *
   *
   * 1 = PendingReview
   *
   * 2 = Approved
   *
   * 3 = Rejected
   *
   * 4 = Expired
   *
   * 5 = Draft
   *
   * 6 = Obsolete
   *
   * 7 = Processed
   */
  StatusId: CertificateStatusType
  /**
   * Date from which the certificate is valid
   * @format date-time
   */
  ValidFrom: string
  /**
   * Date when the certificate expires
   * @format date-time
   */
  ExpirationDate: string
  /** Certificate document url */
  PictureUrl: string
  /** Certificate document thumbnail url */
  ThumbnailUrl?: string | null
  /** List of locations associated with the certificate */
  Locations: LocationResponse[]
  /**
   * Temp field for backward compatibility with mobile app
   * @deprecated
   */
  ProfileIdentityCertificates: any[]
}

/**
 *
 *
 * 1 = CategoryId
 *
 * 2 = ScopeId
 *
 * 3 = IsDeleted
 * @format int32
 */
export enum GetCertificateTypesFilterColumn {
  CategoryId = 1,
  ScopeId = 2,
  IsDeleted = 3,
}

export interface GetCertificateTypesFilterModelDto {
  /**
   *
   *
   * 1 = CategoryId
   *
   * 2 = ScopeId
   *
   * 3 = IsDeleted
   */
  Field: GetCertificateTypesFilterColumn
  /**
   *
   *
   * 1 = IsAnyOf
   *
   * 2 = Is
   */
  Operator: GetCertificateTypesFilterOperator
  Value: string
}

/**
 *
 *
 * 1 = IsAnyOf
 *
 * 2 = Is
 * @format int32
 */
export enum GetCertificateTypesFilterOperator {
  IsAnyOf = 1,
  Is = 2,
}

export interface GetCertificateTypesPaginatedResponse {
  /** Certificate types list */
  CertificateTypes: CertificateTypeResponse[]
  /**
   * Certificate types total count
   * @format int32
   */
  TotalCount: number
}

/**
 *
 *
 * 1 = CreatedOn
 * @format int32
 */
export enum GetCertificateTypesSortColumn {
  CreatedOn = 1,
}

/**
 *
 *
 * 1 = StatusId
 *
 * 2 = ValidFrom
 *
 * 3 = ExpirationDate
 *
 * 4 = TypeName
 *
 * 5 = Owner
 *
 * 6 = Location
 *
 * 7 = Scope
 *
 * 8 = Category
 *
 * 9 = Type
 * @format int32
 */
export enum GetCertificatesFilterColumn {
  StatusId = 1,
  ValidFrom = 2,
  ExpirationDate = 3,
  TypeName = 4,
  Owner = 5,
  Location = 6,
  Scope = 7,
  Category = 8,
  Type = 9,
}

export interface GetCertificatesFilterModelDto {
  /**
   *
   *
   * 1 = StatusId
   *
   * 2 = ValidFrom
   *
   * 3 = ExpirationDate
   *
   * 4 = TypeName
   *
   * 5 = Owner
   *
   * 6 = Location
   *
   * 7 = Scope
   *
   * 8 = Category
   *
   * 9 = Type
   */
  Field: GetCertificatesFilterColumn
  /**
   *
   *
   * 1 = IsAnyOf
   *
   * 2 = Is
   *
   * 3 = After
   *
   * 4 = Before
   *
   * 5 = Between
   *
   * 6 = TypeIs
   *
   * 7 = Contains
   */
  Operator: GetCertificatesFilterOperator
  Value: string
}

/**
 *
 *
 * 1 = IsAnyOf
 *
 * 2 = Is
 *
 * 3 = After
 *
 * 4 = Before
 *
 * 5 = Between
 *
 * 6 = TypeIs
 *
 * 7 = Contains
 * @format int32
 */
export enum GetCertificatesFilterOperator {
  IsAnyOf = 1,
  Is = 2,
  After = 3,
  Before = 4,
  Between = 5,
  TypeIs = 6,
  Contains = 7,
}

export interface GetCertificatesPaginatedResponse {
  /** Certificate list */
  Certificates: GetCertificateResponse[]
  /**
   * Certificates total count
   * @format int32
   */
  TotalCount: number
}

/**
 *
 *
 * 1 = CreatedOn
 *
 * 2 = ValidFrom
 *
 * 3 = ExpirationDate
 * @format int32
 */
export enum GetCertificatesSortColumn {
  CreatedOn = 1,
  ValidFrom = 2,
  ExpirationDate = 3,
}

/**
 *
 *
 * 1 = CertificateTypes
 * @format int32
 */
export enum GetQualificationFilterColumn {
  CertificateTypes = 1,
}

/**
 *
 *
 * 1 = IsAnyOf
 *
 * 2 = Is
 *
 * 3 = Contains
 *
 * 4 = TypeAreAnyOf
 * @format int32
 */
export enum GetQualificationFilterOperator {
  IsAnyOf = 1,
  Is = 2,
  Contains = 3,
  TypeAreAnyOf = 4,
}

export interface GetQualificationIdsByGuidsResponse {
  /**
   * Unique identifier of the identity user within the system
   * @format uuid
   */
  UserGuid: string
  /** List of qualification identifiers associated with the user */
  QualificationIds: number[]
}

export interface GetQualificationResponse {
  /**
   * Unique identifier of the qualification within the system
   * @format int32
   */
  Id: number
  /** Flag indicating whether the qualification is deleted */
  IsDeleted: boolean
  /**
   * Qualification creation date
   * @format date-time
   */
  CreatedOn: string
  /** Qualification name */
  Name: string
  /**
   * Latest qualification version identifier
   * @format int32
   */
  LatestQualificationVersionId: number
  /**
   * Unique identifier of the tenant associated with the qualification
   * @format int32
   */
  TenantId: number
  /**
   * Unique identifier of the corporation associated with the qualification
   * @format int32
   */
  CorporationId?: number | null
  /**
   *
   *
   * 1 = Corporation
   *
   * 2 = Tenant
   */
  VisibilityScope: QualificationVisibilityScope
  /** List of certificate types associated with the qualification */
  CertificateTypes: QualificationCertificateTypeResponse[]
}

/**
 *
 *
 * 1 = CreatedOn
 * @format int32
 */
export enum GetQualificationSortColumn {
  CreatedOn = 1,
}

export interface GetQualificationVersionResponse {
  /**
   * Unique identifier of the qualification within the system
   * @format int32
   */
  QualificationId: number
  /**
   * Qualification creation date
   * @format date-time
   */
  QualificationCreatedOn: string
  /** Qualification name */
  QualificationName: string
  /**
   *
   *
   * 1 = Corporation
   *
   * 2 = Tenant
   */
  QualificationVisibilityScope: QualificationVisibilityScope
  /**
   * Latest qualification version identifier
   * @format int32
   */
  LatestQualificationVersionId: number
  /**
   * Qualification owner unique identity identifier within the system
   * @format uuid
   */
  QualificationOwnerGuid: string
  /**
   * Qualification version unique identifier within the system
   * @format int32
   */
  VersionId: number
  /**
   * Qualification version creation date
   * @format date-time
   */
  VersionCreatedOn: string
  /** Qualification version name */
  VersionName: string
  /**
   * Qualification version expiration date
   * @format date-time
   */
  VersionExpirationDate?: string | null
  /** Qualification version certificate types */
  VersionCertificateTypes: QualificationCertificateTypeResponse[]
  /**
   * Qualification version owner unique identity identifier within the system
   * @format uuid
   */
  VersionOwnerGuid: string
}

export interface GetQualificationVersionsResponse {
  /**
   * Qualification version unique identifier within the system
   * @format int32
   */
  Id: number
  /**
   * Qualification version creation date
   * @format date-time
   */
  CreatedOn: string
  /** Qualification version name */
  Name: string
  /** Flag indicating whether the qualification version is expired */
  IsExpired: boolean
  /** Flag indicating whether the qualification version is the latest version */
  IsLatest: boolean
}

export interface GetQualificationsPaginatedResponse {
  /** Qualifications list */
  Qualifications: GetQualificationResponse[]
  /**
   * Qualifications total count
   * @format int32
   */
  TotalCount: number
}

/**
 *
 *
 * 1 = AssignedToUserId
 *
 * 2 = AssignerId
 *
 * 3 = StatusId
 *
 * 4 = QualificationVersionCertificateTypes
 * @format int32
 */
export enum GetUserQualificationFilterColumn {
  AssignedToUserId = 1,
  AssignerId = 2,
  StatusId = 3,
  QualificationVersionCertificateTypes = 4,
}

/**
 *
 *
 * 1 = IsAnyOf
 *
 * 2 = Is
 *
 * 3 = Contains
 *
 * 4 = TypeAreAnyOf
 * @format int32
 */
export enum GetUserQualificationFilterOperator {
  IsAnyOf = 1,
  Is = 2,
  Contains = 3,
  TypeAreAnyOf = 4,
}

export interface GetUserQualificationResponse {
  /**
   * Unique identifier of the user qualification within the system
   * @format int32
   */
  Id: number
  /** Flag indicating whether the user qualification is deleted */
  IsDeleted: boolean
  /**
   * User qualification creation date
   * @format date-time
   */
  CreatedOn: string
  /**
   * Unique identifier of the user to whom the qualification is assigned
   * @format uuid
   */
  AssignedToUserId: string
  /**
   * Unique identifier of the user who assigned the qualification
   * @format uuid
   */
  AssignerId: string
  /**
   *
   *
   * 1 = Pending
   *
   * 2 = Active
   *
   * 3 = Revoked
   *
   * 4 = CertificateExpired
   *
   * 5 = VersionExpired
   *
   * 6 = CertificateTypeDeleted
   *
   * 7 = QualificationDeleted
   */
  StatusId: UserAssignedQualificationStatusType
  /**
   * Unique identifier of the qualification version
   * @format int32
   */
  QualificationVersionId: number
  /** Qualification version name */
  QualificationVersionName: string
  /**
   * Qualification version expiration date
   * @format date-time
   */
  QualificationVersionExpirationDate?: string | null
  /** List of certificate types associated with the qualification version */
  QualificationVersionCertificateTypes: QualificationCertificateTypeResponse[]
}

/**
 *
 *
 * 1 = QualificationVersionExpirationDate
 * @format int32
 */
export enum GetUserQualificationSortColumn {
  QualificationVersionExpirationDate = 1,
}

export interface GetUserQualificationsByIdsRequest {
  /**
   * List of qualification ids
   * @minItems 1
   */
  QualificationIds: number[]
  /**
   * Unique identifier of the user
   * @format uuid
   */
  UserId: string
}

export interface GetUserQualificationsPaginatedResponse {
  /** User qualifications list */
  UserQualifications: GetUserQualificationResponse[]
  /**
   * User qualifications total count
   * @format int32
   */
  TotalCount: number
}

export interface IdentityCertificateResponse {
  /**
   * Unique identifier of the certificate within the system
   * @format int32
   */
  Id: number
  /** Flag indicating whether the certificate is deleted */
  IsDeleted: boolean
  /**
   * Certificate creation date
   * @format date-time
   */
  CreatedOn: string
  /** Certificate serial number */
  SerialNumber?: string | null
  /** Certificate authority */
  Authority?: string | null
  /**
   * Certificate type identifier
   * @format int32
   */
  TypeId: number
  /** Certificate type name */
  TypeName: string
  /**
   *
   *
   * 1 = UserCertificate
   *
   * 2 = ProfileCertificate
   *
   * 3 = TenantCertificate
   */
  ScopeId: CertificateScopeType
  /**
   * Unique identifier of the owner profile associated with the certificate
   * @format int32
   */
  OwnerProfileId?: number | null
  /**
   * Unique identifier of the owner identity associated with the certificate
   * @format uuid
   */
  OwnerIdentityGuid?: string | null
  /**
   * Unique identifier of the tenant associated with the certificate
   * @format int32
   */
  TenantId?: number | null
  /** Name of the tenant associated with the certificate */
  TenantName?: string | null
  /** Subdomain of the tenant associated with the certificate */
  TenantSubdomain?: string | null
  /**
   *
   *
   * 1 = PendingReview
   *
   * 2 = Approved
   *
   * 3 = Rejected
   *
   * 4 = Expired
   *
   * 5 = Draft
   *
   * 6 = Obsolete
   *
   * 7 = Processed
   */
  StatusId: CertificateStatusType
  /**
   * Date from which the certificate is valid
   * @format date-time
   */
  ValidFrom: string
  /**
   * Date when the certificate expires
   * @format date-time
   */
  ExpirationDate: string
  /** Certificate document url */
  PictureUrl: string
  /** Certificate document thumbnail url */
  ThumbnailUrl?: string | null
  /** List of locations associated with the certificate */
  Locations: LocationResponse[]
  /**
   * Temp field for backward compatibility with mobile app
   * @deprecated
   */
  ProfileIdentityCertificates: any[]
  /**
   * Certificate category identifier
   * @format int32
   */
  CategoryId: number
  /** Certificate category name */
  CategoryName: string
  /** Certificate rejection reason */
  RejectionReason?: string | null
}

export interface LocationResponse {
  /**
   * Unique identifier of the location within the system
   * @format int32
   */
  Id: number
  /** Location name */
  Name: string
  /**
   * Unique identifier of the country within the system
   * @format int32
   */
  CountryId: number
  /** Location country name */
  CountryName: string
}

/**
 *
 *
 * 1 = Day
 *
 * 2 = Month
 *
 * 3 = Year
 * @format int32
 */
export enum PeriodUnitType {
  Day = 1,
  Month = 2,
  Year = 3,
}

export interface QualificationCertificateTypeResponse {
  /**
   * Unique identifier of the certificate type within the system
   * @format int32
   */
  Id: number
  /** Flag indicating whether the certificate type is deleted */
  IsDeleted: boolean
  /** Qualification certificate type name */
  Name: string
  /**
   * Qualification certificate type category unique identifier
   * @format int32
   */
  CategoryId: number
  /** Qualification certificate type category name */
  CategoryName: string
  /**
   *
   *
   * 1 = UserCertificate
   *
   * 2 = ProfileCertificate
   *
   * 3 = TenantCertificate
   */
  ScopeId: CertificateScopeType
}

export interface QualificationFilterModelDto {
  /**
   *
   *
   * 1 = CertificateTypes
   */
  Field: GetQualificationFilterColumn
  /**
   *
   *
   * 1 = IsAnyOf
   *
   * 2 = Is
   *
   * 3 = Contains
   *
   * 4 = TypeAreAnyOf
   */
  Operator: GetQualificationFilterOperator
  Value: string
}

/**
 *
 *
 * 1 = Corporation
 *
 * 2 = Tenant
 * @format int32
 */
export enum QualificationVisibilityScope {
  Corporation = 1,
  Tenant = 2,
}

/**
 *
 *
 * 1 = Tenant
 *
 * 2 = Corporation
 * @format int32
 */
export enum RequestScope {
  Tenant = 1,
  Corporation = 2,
}

export interface SearchQualificationResponse {
  /**
   * Unique identifier of the qualification
   * @format int32
   */
  Id: number
  /** Qualification name */
  Name: string
}

export interface SearchQualificationVersionsResponse {
  /**
   * Unique identifier of the qualification version within the system
   * @format int32
   */
  Id: number
  /** Qualification version name */
  Name: string
  /**
   * Qualification version expiration date
   * @format date-time
   */
  ExpirationDate?: string | null
  /** List of certificate types associated with the qualification version */
  CertificateTypes: CertificateTypeBaseResponse[]
}

/**
 *
 *
 * 1 = asc
 *
 * 2 = desc
 * @format int32
 */
export enum SortingOrder {
  Asc = 1,
  Desc = 2,
}

export interface UpdateQualificationRequest {
  /**
   * Unique identifier of the qualification
   * @format int32
   */
  Id: number
  /**
   * Qualification name
   * @minLength 1
   * @maxLength 256
   * @pattern ^[\S]+(\s+[\S]+)*$
   */
  Name: string
}

export interface UpdateQualificationVersionsRequest {
  /**
   * Unique identifier of the qualification version to be updated
   * @format int32
   */
  Id: number
  /**
   * Qualification version expiration date
   * @format date-time
   */
  ExpirationDate?: string | null
}

/**
 *
 *
 * 1 = Pending
 *
 * 2 = Active
 *
 * 3 = Revoked
 *
 * 4 = CertificateExpired
 *
 * 5 = VersionExpired
 *
 * 6 = CertificateTypeDeleted
 *
 * 7 = QualificationDeleted
 * @format int32
 */
export enum UserAssignedQualificationStatusType {
  Pending = 1,
  Active = 2,
  Revoked = 3,
  CertificateExpired = 4,
  VersionExpired = 5,
  CertificateTypeDeleted = 6,
  QualificationDeleted = 7,
}

export interface UserAssignedQualificationVersionResponse {
  /**
   * Unique identifier of the qualification version within the system
   * @format int32
   */
  QualificationVersionId: number
  /**
   *
   *
   * 1 = Pending
   *
   * 2 = Active
   *
   * 3 = Revoked
   *
   * 4 = CertificateExpired
   *
   * 5 = VersionExpired
   *
   * 6 = CertificateTypeDeleted
   *
   * 7 = QualificationDeleted
   */
  Status: UserAssignedQualificationStatusType
}

export interface UserQualificationFilterModelDto {
  /**
   *
   *
   * 1 = AssignedToUserId
   *
   * 2 = AssignerId
   *
   * 3 = StatusId
   *
   * 4 = QualificationVersionCertificateTypes
   */
  Field: GetUserQualificationFilterColumn
  /**
   *
   *
   * 1 = IsAnyOf
   *
   * 2 = Is
   *
   * 3 = Contains
   *
   * 4 = TypeAreAnyOf
   */
  Operator: GetUserQualificationFilterOperator
  Value: string
}

export interface UserQualificationResponse {
  /**
   * Unique identifier of the qualification within the system
   * @format int32
   */
  QualificationId: number
  /** Qualification name */
  QualificationName: string
  /** Qualification versions */
  Versions: UserAssignedQualificationVersionResponse[]
}

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://api-dev.collaborate.center/staging/',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Certificates service api
 * @baseUrl https://api-dev.collaborate.center/staging/
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  certificateCategories = {
    /**
     * No description
     *
     * @tags CertificateCategories
     * @name GetAllAsync
     * @summary Get all certificate categories
     * @request GET:/certificate-service/api/certificate-categories
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<CertificateCategory[], ApiErrorResponse>({
        path: `/certificate-service/api/certificate-categories`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  certificates = {
    /**
     * No description
     *
     * @tags Certificates
     * @name GetMyWithPaginationAsync
     * @summary Get my certificates with pagination
     * @request GET:/certificate-service/api/certificates/my
     */
    getMyWithPaginationAsync: (
      query?: {
        /** Search text */
        Search?: string
        /**
         *
         *
         * 1 = CreatedOn
         *
         * 2 = ValidFrom
         *
         * 3 = ExpirationDate
         */
        'Sort.Field'?: GetCertificatesSortColumn
        /**
         *
         *
         * 1 = asc
         *
         * 2 = desc
         */
        'Sort.SortOrder'?: SortingOrder
        /** Filter models */
        FilterModels?: GetCertificatesFilterModelDto[]
        /**
         * Request scope
         *
         * 1 = Tenant
         *
         * 2 = Corporation
         */
        Scope?: RequestScope
        /**
         * Page number
         * @format int32
         */
        PageNumber?: number
        /**
         * Page size
         * @format int32
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetCertificatesPaginatedResponse, ApiErrorResponse>({
        path: `/certificate-service/api/certificates/my`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Certificates
     * @name GetAllWithPaginationAsync
     * @summary Get all certificates with pagination
     * @request GET:/certificate-service/api/certificates/paginated
     */
    getAllWithPaginationAsync: (
      query?: {
        /** Search text */
        Search?: string
        /**
         *
         *
         * 1 = CreatedOn
         *
         * 2 = ValidFrom
         *
         * 3 = ExpirationDate
         */
        'Sort.Field'?: GetCertificatesSortColumn
        /**
         *
         *
         * 1 = asc
         *
         * 2 = desc
         */
        'Sort.SortOrder'?: SortingOrder
        /** Filter models */
        FilterModels?: GetCertificatesFilterModelDto[]
        /**
         * Request scope
         *
         * 1 = Tenant
         *
         * 2 = Corporation
         */
        Scope?: RequestScope
        /**
         * Page number
         * @format int32
         */
        PageNumber?: number
        /**
         * Page size
         * @format int32
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetCertificatesPaginatedResponse, ApiErrorResponse>({
        path: `/certificate-service/api/certificates/paginated`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Certificates
     * @name GetForUserAsync
     * @summary Get all certificates of the contract's user with pagination
     * @request GET:/certificate-service/api/certificates/user
     */
    getForUserAsync: (
      query: {
        /**
         * Unique identity identifier of the user within the system
         * @format uuid
         */
        UserGuid: string
        /**
         * Unique identifier of the user profile within the system
         * @format int32
         */
        UserId: number
        /** Search text */
        Search?: string
        /**
         *
         *
         * 1 = CreatedOn
         *
         * 2 = ValidFrom
         *
         * 3 = ExpirationDate
         */
        'Sort.Field'?: GetCertificatesSortColumn
        /**
         *
         *
         * 1 = asc
         *
         * 2 = desc
         */
        'Sort.SortOrder'?: SortingOrder
        /** Filter models */
        FilterModels?: GetCertificatesFilterModelDto[]
        /**
         * Request scope
         *
         * 1 = Tenant
         *
         * 2 = Corporation
         */
        Scope?: RequestScope
        /**
         * Page number
         * @format int32
         */
        PageNumber?: number
        /**
         * Page size
         * @format int32
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetCertificatesPaginatedResponse, ApiErrorResponse>({
        path: `/certificate-service/api/certificates/user`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Certificates
     * @name GetForContractedTenantAsync
     * @summary Get all certificates with pagination
     * @request GET:/certificate-service/api/certificates/contract
     */
    getForContractedTenantAsync: (
      query: {
        /**
         * Unique identifier of the contract version within the system
         * @format int32
         */
        ContractVersionId: number
        /** Search text */
        Search?: string
        /**
         *
         *
         * 1 = CreatedOn
         *
         * 2 = ValidFrom
         *
         * 3 = ExpirationDate
         */
        'Sort.Field'?: GetCertificatesSortColumn
        /**
         *
         *
         * 1 = asc
         *
         * 2 = desc
         */
        'Sort.SortOrder'?: SortingOrder
        /** Filter models */
        FilterModels?: GetCertificatesFilterModelDto[]
        /**
         * Request scope
         *
         * 1 = Tenant
         *
         * 2 = Corporation
         */
        Scope?: RequestScope
        /**
         * Page number
         * @format int32
         */
        PageNumber?: number
        /**
         * Page size
         * @format int32
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetCertificatesPaginatedResponse, ApiErrorResponse>({
        path: `/certificate-service/api/certificates/contract`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Certificates
     * @name GetForContractUserAsync
     * @summary Get all certificates of the contract's user with pagination
     * @request GET:/certificate-service/api/certificates/contract/user
     */
    getForContractUserAsync: (
      query: {
        /**
         * Unique identifier of the contractor source tenant
         * @format int32
         */
        ContractorSourceTenantId: number
        /**
         * Unique identifier of the user for whom to get the certificates
         * @format uuid
         */
        UserGuid: string
        /** Search text */
        Search?: string
        /**
         *
         *
         * 1 = CreatedOn
         *
         * 2 = ValidFrom
         *
         * 3 = ExpirationDate
         */
        'Sort.Field'?: GetCertificatesSortColumn
        /**
         *
         *
         * 1 = asc
         *
         * 2 = desc
         */
        'Sort.SortOrder'?: SortingOrder
        /** Filter models */
        FilterModels?: GetCertificatesFilterModelDto[]
        /**
         * Request scope
         *
         * 1 = Tenant
         *
         * 2 = Corporation
         */
        Scope?: RequestScope
        /**
         * Page number
         * @format int32
         */
        PageNumber?: number
        /**
         * Page size
         * @format int32
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetCertificatesPaginatedResponse, ApiErrorResponse>({
        path: `/certificate-service/api/certificates/contract/user`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Certificates
     * @name GetByIdAsync
     * @summary Get certificate by id
     * @request GET:/certificate-service/api/certificates/{id}
     */
    getByIdAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<IdentityCertificateResponse, ApiErrorResponse>({
        path: `/certificate-service/api/certificates/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Certificates
     * @name DeleteAsync
     * @summary Delete certificate
     * @request DELETE:/certificate-service/api/certificates/{id}
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/certificates/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Certificates
     * @name CreateAsync
     * @summary Create certificate
     * @request POST:/certificate-service/api/certificates
     */
    createAsync: (data: CreateCertificateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/certificates`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Certificates
     * @name UpdateAsync
     * @summary Update certificate
     * @request PUT:/certificate-service/api/certificates
     */
    updateAsync: (data: CertificateUpdateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/certificates`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Certificates
     * @name ReviewAsync
     * @summary Review certificate
     * @request PUT:/certificate-service/api/certificates/review
     */
    reviewAsync: (data: CertificateReviewRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/certificates/review`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  }
  certificateTypes = {
    /**
     * No description
     *
     * @tags CertificateTypes
     * @name GetAllWithPaginationAsync
     * @summary Get all certificates types with pagination
     * @request GET:/certificate-service/api/certificateTypes/paginated
     */
    getAllWithPaginationAsync: (
      query?: {
        /** Search text */
        Search?: string
        /**
         *
         *
         * 1 = CreatedOn
         */
        'Sort.Field'?: GetCertificateTypesSortColumn
        /**
         *
         *
         * 1 = asc
         *
         * 2 = desc
         */
        'Sort.SortOrder'?: SortingOrder
        /** Filter models */
        FilterModels?: GetCertificateTypesFilterModelDto[]
        /**
         * Page number
         * @format int32
         */
        PageNumber?: number
        /**
         * Page size
         * @format int32
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetCertificateTypesPaginatedResponse, ApiErrorResponse>({
        path: `/certificate-service/api/certificateTypes/paginated`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CertificateTypes
     * @name GetAllAsync
     * @summary Get all certificates types
     * @request GET:/certificate-service/api/certificateTypes/all
     */
    getAllAsync: (
      query?: {
        /** Search text */
        Search?: string
        /** Show current user certificates only */
        ShowCurrentUserCertificates?: boolean
        /** Certificate scope types to filter by */
        CertificateScopeTypes?: CertificateScopeType[]
      },
      params: RequestParams = {}
    ) =>
      this.http.request<CertificateTypeBaseResponse[], ApiErrorResponse>({
        path: `/certificate-service/api/certificateTypes/all`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CertificateTypes
     * @name GetApprovedTypeIdsByUserGuidAsync
     * @summary Get all available certificate type ids
     * @request GET:/certificate-service/api/certificateTypes/approved/user/{userGuid}
     */
    getApprovedTypeIdsByUserGuidAsync: (userGuid: string, params: RequestParams = {}) =>
      this.http.request<number[], ApiErrorResponse>({
        path: `/certificate-service/api/certificateTypes/approved/user/${userGuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CertificateTypes
     * @name CreateAsync
     * @summary Create certificate type
     * @request POST:/certificate-service/api/certificateTypes
     */
    createAsync: (data: CertificateTypeCreateRequest, params: RequestParams = {}) =>
      this.http.request<CertificateTypeResponse, ApiErrorResponse>({
        path: `/certificate-service/api/certificateTypes`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CertificateTypes
     * @name UpdateAsync
     * @summary Update certificate type
     * @request PUT:/certificate-service/api/certificateTypes
     */
    updateAsync: (data: CertificateTypeUpdateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/certificateTypes`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CertificateTypes
     * @name RestoreAsync
     * @summary Restore certificate type
     * @request PUT:/certificate-service/api/certificateTypes/restore/{id}
     */
    restoreAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/certificateTypes/restore/${id}`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CertificateTypes
     * @name DeleteAsync
     * @summary Delete certificate type
     * @request DELETE:/certificate-service/api/certificateTypes/{id}
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/certificateTypes/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CertificateTypes
     * @name DeletePermanentlyAsync
     * @summary Delete certificate type permanently
     * @request DELETE:/certificate-service/api/certificateTypes/{id}/permanently
     */
    deletePermanentlyAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/certificateTypes/${id}/permanently`,
        method: 'DELETE',
        ...params,
      }),
  }
  locations = {
    /**
     * No description
     *
     * @tags Locations
     * @name GetAllLocationsAsync
     * @summary Get all available locations
     * @request GET:/certificate-service/api/locations
     */
    getAllLocationsAsync: (params: RequestParams = {}) =>
      this.http.request<LocationResponse[], ApiErrorResponse>({
        path: `/certificate-service/api/locations`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  qualifications = {
    /**
     * No description
     *
     * @tags Qualifications
     * @name GetAllWithPaginationAsync
     * @summary Get all qualification with pagination
     * @request GET:/certificate-service/api/qualifications/paginated
     */
    getAllWithPaginationAsync: (
      query?: {
        /** Search text */
        Search?: string
        /**
         *
         *
         * 1 = CreatedOn
         */
        'Sort.Field'?: GetQualificationSortColumn
        /**
         *
         *
         * 1 = asc
         *
         * 2 = desc
         */
        'Sort.SortOrder'?: SortingOrder
        /** Filter models */
        FilterModels?: QualificationFilterModelDto[]
        /**
         * Page number
         * @format int32
         */
        PageNumber?: number
        /**
         * Page size
         * @format int32
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetQualificationsPaginatedResponse, ApiErrorResponse>({
        path: `/certificate-service/api/qualifications/paginated`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Qualifications
     * @name GetSearchedAsync
     * @summary Search qualifications
     * @request GET:/certificate-service/api/qualifications
     */
    getSearchedAsync: (
      query?: {
        /** @default "" */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<SearchQualificationResponse[], ApiErrorResponse>({
        path: `/certificate-service/api/qualifications`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Qualifications
     * @name CreateAsync
     * @summary Create qualification
     * @request POST:/certificate-service/api/qualifications
     */
    createAsync: (data: CreateQualificationRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/qualifications`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Qualifications
     * @name UpdateAsync
     * @summary Update qualification
     * @request PUT:/certificate-service/api/qualifications
     */
    updateAsync: (data: UpdateQualificationRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/qualifications`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Qualifications
     * @name GetByIdsAsync
     * @summary Get qualifications by ids
     * @request GET:/certificate-service/api/qualifications/by-ids
     */
    getByIdsAsync: (
      query?: {
        ids?: number[]
      },
      params: RequestParams = {}
    ) =>
      this.http.request<SearchQualificationResponse[], ApiErrorResponse>({
        path: `/certificate-service/api/qualifications/by-ids`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Qualifications
     * @name DeleteAsync
     * @summary Delete qualification
     * @request DELETE:/certificate-service/api/qualifications/{id}
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/qualifications/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Qualifications
     * @name RestoreAsync
     * @summary Restore qualification
     * @request PUT:/certificate-service/api/qualifications/restore/{id}
     */
    restoreAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/qualifications/restore/${id}`,
        method: 'PUT',
        ...params,
      }),
  }
  qualificationVersions = {
    /**
     * No description
     *
     * @tags QualificationVersions
     * @name GetVersionsAsync
     * @summary Gey all versions of qualification
     * @request GET:/certificate-service/api/qualifications/{qualificationId}/versions
     */
    getVersionsAsync: (qualificationId: number, params: RequestParams = {}) =>
      this.http.request<GetQualificationVersionsResponse[], ApiErrorResponse>({
        path: `/certificate-service/api/qualifications/${qualificationId}/versions`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags QualificationVersions
     * @name GetSearchedAsync
     * @summary Search qualification versions
     * @request GET:/certificate-service/api/qualifications/versions
     */
    getSearchedAsync: (
      query?: {
        /** @default "" */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<SearchQualificationVersionsResponse[], ApiErrorResponse>({
        path: `/certificate-service/api/qualifications/versions`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags QualificationVersions
     * @name CreateVersionAsync
     * @summary Create new qualification version
     * @request POST:/certificate-service/api/qualifications/versions
     */
    createVersionAsync: (data: CreateQualificationVersionRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/qualifications/versions`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags QualificationVersions
     * @name UpdateVersionsAsync
     * @summary Update qualification version
     * @request PUT:/certificate-service/api/qualifications/versions
     */
    updateVersionsAsync: (data: UpdateQualificationVersionsRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/qualifications/versions`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags QualificationVersions
     * @name GetVersionAsync
     * @summary Get qualification version
     * @request GET:/certificate-service/api/qualifications/{qualificationId}/versions/{versionId}
     */
    getVersionAsync: (qualificationId: number, versionId: number, params: RequestParams = {}) =>
      this.http.request<GetQualificationVersionResponse, ApiErrorResponse>({
        path: `/certificate-service/api/qualifications/${qualificationId}/versions/${versionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  userQualifications = {
    /**
     * No description
     *
     * @tags UserQualifications
     * @name GetAllWithPaginationAsync
     * @summary Get user qualifications with pagination
     * @request GET:/certificate-service/api/userQualifications/paginated
     */
    getAllWithPaginationAsync: (
      query?: {
        /**
         * Unique identifier of the identity user within the system
         * @format uuid
         */
        UserGuid?: string
        /**
         *
         *
         * 1 = QualificationVersionExpirationDate
         */
        'Sort.Field'?: GetUserQualificationSortColumn
        /**
         *
         *
         * 1 = asc
         *
         * 2 = desc
         */
        'Sort.SortOrder'?: SortingOrder
        /** Filter models */
        FilterModels?: UserQualificationFilterModelDto[]
        /**
         * Request scope
         *
         * 1 = Tenant
         *
         * 2 = Corporation
         */
        Scope?: RequestScope
        /**
         * Page number
         * @format int32
         */
        PageNumber?: number
        /**
         * Page size
         * @format int32
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetUserQualificationsPaginatedResponse, ApiErrorResponse>({
        path: `/certificate-service/api/userQualifications/paginated`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserQualifications
     * @name GetByContent
     * @summary Get user qualifications with pagination
     * @request POST:/certificate-service/api/userQualifications/by-content
     */
    getByContent: (
      query: {
        /** @format int32 */
        contentId: number
      },
      data: GetUserQualificationsByIdsRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<UserQualificationResponse[], ApiErrorResponse>({
        path: `/certificate-service/api/userQualifications/by-content`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserQualifications
     * @name GetForContractAsync
     * @summary Get user qualifications for contract
     * @request GET:/certificate-service/api/userQualifications/contract
     */
    getForContractAsync: (
      query: {
        /**
         * Unique identifier of the contract version within the system
         * @format int32
         */
        ContractVersionId: number
        /**
         *
         *
         * 1 = QualificationVersionExpirationDate
         */
        'Sort.Field'?: GetUserQualificationSortColumn
        /**
         *
         *
         * 1 = asc
         *
         * 2 = desc
         */
        'Sort.SortOrder'?: SortingOrder
        /** Filter models */
        FilterModels?: UserQualificationFilterModelDto[]
        /**
         * Request scope
         *
         * 1 = Tenant
         *
         * 2 = Corporation
         */
        Scope?: RequestScope
        /**
         * Page number
         * @format int32
         */
        PageNumber?: number
        /**
         * Page size
         * @format int32
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetUserQualificationsPaginatedResponse, ApiErrorResponse>({
        path: `/certificate-service/api/userQualifications/contract`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserQualifications
     * @name GetActiveIdsAsync
     * @summary Get active user qualification ids by user guids
     * @request GET:/certificate-service/api/userQualifications/active
     */
    getActiveIdsAsync: (
      query?: {
        /** User GUIDs to get their qualification IDs */
        UserGuids?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GetQualificationIdsByGuidsResponse[], ApiErrorResponse>({
        path: `/certificate-service/api/userQualifications/active`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserQualifications
     * @name RevokeAsync
     * @summary Revoke user qualification
     * @request PUT:/certificate-service/api/userQualifications/{userQualificationId}/status/revoke
     */
    revokeAsync: (userQualificationId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/userQualifications/${userQualificationId}/status/revoke`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserQualifications
     * @name RestoreAsync
     * @summary Restore user qualification
     * @request PUT:/certificate-service/api/userQualifications/{userQualificationId}/user/{userGuid}/status/restore
     */
    restoreAsync: (userQualificationId: number, userGuid: string, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/certificate-service/api/userQualifications/${userQualificationId}/user/${userGuid}/status/restore`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserQualifications
     * @name CreateUserQualificationAsync
     * @summary Create user qualification
     * @request POST:/certificate-service/api/userQualifications
     */
    createUserQualificationAsync: (data: CreateUserQualificationRequest, params: RequestParams = {}) =>
      this.http.request<CreateUserQualificationResponse, ApiErrorResponse>({
        path: `/certificate-service/api/userQualifications`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
}
